import bemBlock from "@gik/core/utils/bemBlock";
import { getAssetsUrl } from "@gik/core/utils/LinkUtils";
import withComponentErrorBoundary from "@gik/core/utils/withComponentErrorBoundary";
import { HTMLParser } from "@gik/ui-legacy/HTMLParser";
import { Image } from "@gik/ui-legacy/Image";
import type React from "react";
import { useTranslation } from "react-i18next";
import { translationKeys } from "./i18n/en";

function BenefitsHeroComp(): React.ReactElement {
	const bem = bemBlock("benefits-page-hero");
	const bemItem = bemBlock("benefits-page-hero-item");
	const { t } = useTranslation();

	return (
		<div className={bem()}>
			<div className={bemItem(null, "danger")}>
				<Image
					src={[
						`${getAssetsUrl()}marketing/benefits/beforeIMG1x.png`,
						`${getAssetsUrl()}marketing/benefits/beforeIMG@2x.png 2x`,
					]}
					alt={t(translationKeys.withoutTitle)}
				/>
				<main>
					<span className={bemItem("title")}>
						{t(translationKeys.withoutTitle).toString()}
					</span>
					<p>
						{HTMLParser({ rawHtml: t(translationKeys.withoutDescription) })}
					</p>
				</main>
			</div>
			<div className={bemItem(null, "success")}>
				<Image
					src={[
						`${getAssetsUrl()}marketing/benefits/afterIMG1x.png`,
						`${getAssetsUrl()}marketing/benefits/afterIMG@2x.png 2x`,
					]}
					alt={t(translationKeys.withTitle)}
				/>
				<main>
					<span className={bemItem("title")}>
						{t(translationKeys.withTitle).toString()}
					</span>
					<p>{HTMLParser({ rawHtml: t(translationKeys.withDescription) })}</p>
				</main>
			</div>
		</div>
	);
}

export const BenefitsHero = withComponentErrorBoundary(BenefitsHeroComp);
